export const DON_D_RECOMMENDATION_DELAY_MIN_MS = 650;
export const DON_D_RECOMMENDATION_DELAY_MAX_MS = 1200;
export const DON_D_RECOMMENDATION_DELAY_ABSOLUTE_MAX_MS = 1500;

export const randomDonDRecommendationDelay = (random = Math.random) => {
  const value = Number(random());
  const normalized = Number.isFinite(value) ? Math.min(Math.max(value, 0), 1) : 0;
  return DON_D_RECOMMENDATION_DELAY_MIN_MS
    + normalized * (DON_D_RECOMMENDATION_DELAY_MAX_MS - DON_D_RECOMMENDATION_DELAY_MIN_MS);
};
